import AsyncStorage from "@react-native-async-storage/async-storage";
import { createClient } from "@supabase/supabase-js";
import Constants from "expo-constants";
import { Platform } from "react-native";

const DEFAULT_SUPABASE_URL = "https://bxqolhsrjuccfwgrhped.supabase.co";
const DEFAULT_SUPABASE_ANON_KEY = "sb_publishable_V9u8OU-TWQv5Ro97DDiZEQ_QRavs5sA";

const extraConfig = Constants.expoConfig?.extra as
  | { SUPABASE_URL?: string; SUPABASE_ANON_KEY?: string }
  | undefined;

const supabaseUrl =
  process.env.SUPABASE_URL ??
  process.env.EXPO_PUBLIC_SUPABASE_URL ??
  extraConfig?.SUPABASE_URL ??
  DEFAULT_SUPABASE_URL;
const supabaseAnonKey =
  process.env.SUPABASE_ANON_KEY ??
  process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY ??
  extraConfig?.SUPABASE_ANON_KEY ??
  DEFAULT_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
export const supabase = createClient(
  supabaseUrl || "https://example.supabase.co",
  supabaseAnonKey || "anon-key",
  {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: false,
      persistSession: true,
      ...(Platform.OS !== "web" ? { storage: AsyncStorage } : {}),
    },
  },
);

export const ensureSupabaseConfigured = () => {
  if (!isSupabaseConfigured) {
    console.warn(
      "Supabase is not configured. Set SUPABASE_URL and SUPABASE_ANON_KEY.",
    );
  }
};
